import { render } from "./NavBarCategoryIcon.vue?vue&type=template&id=6e603ea2&scoped=true"
import script from "./NavBarCategoryIcon.vue?vue&type=script&lang=js"
export * from "./NavBarCategoryIcon.vue?vue&type=script&lang=js"

import "./NavBarCategoryIcon.vue?vue&type=style&index=0&id=6e603ea2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e603ea2"]])

export default __exports__